<template lang='pug'>
.introduceDetail2-container(v-if="!bookMarksLoading")
    .introduce-allContainer
        topContent(:bigTitle="introduceName",:smallTitle="introduceName2" :style="{marginBottom:'0.8rem'}" :img="data.bigImg" :introduceId='introduceId' :introduceId2='introduceId2' )
        .img-container
            img(v-src='data.bigImg')
        .content-container(v-html="data.des")
        .content(v-html="data.content")
    .buy-container(v-if="data.buy_url")
            img(src="@/assets/imgs/购物车@3x.png")
            .goumai(@click="push") 点击购买
        
</template>

<script>
import { mapState } from 'vuex'
import topContent from './components/topContent'
import { getDataRow, concatWithSymbol } from '@custouch/proxy-use'
import { getCmsStr, getRowPath } from './levelTitle'
export default {
    name:'introduceDetail2',
    props:['introduceId2','introduceId'],
    async created() {
        const [{ detail, tagIds },{ path }] = await Promise.all([getDataRow({dataRowId: this.introduceId2}),getRowPath(this.introduceId2,this.$route.meta.mId,this.introduceId)])
        this.introduceName = detail.title ? detail.title : ''
        this.introduceName2 = detail.name ? detail.name : ''
        this.data = detail
        const cms = getCmsStr({mId: this.$route.meta.mId,hId: this.introduceId,rId: this.introduceId2})
        this.$root.$emit('pageview',{title:concatWithSymbol([this.$route.meta.title,path,this.introduceName2]),cms,tagIds: tagIds.join(',')})
        this.$root.$emit('updateShare',{title:this.introduceName2+'-'+document.title})
        this.$root.$emit('action',{name:this.$route.name,introduceName:this.introduceName,introduceName2:this.introduceName2})
        this.data.des=this.data.des.replace(/\\r\\n/gi,'<br>')
    },
    components:{
        topContent
    },
    computed:{
        ...mapState(['bookMarks','memberInfo','bookMarksLoading'])
    },
    methods:{
        push(){
            window.location.href=this.data.buy_url
        }
    },
    data() {
        return {
            data:{},
            introduceName:'',
            introduceName2:'',
        }
    }
}
</script>

<style scoped lang='less'>
.introduce-allContainer{

    height: 100%;
    overflow: auto;
    padding-left:1rem;
    padding-right: 1rem;;
}
.introduceDetail2-container{
    padding-bottom: 3rem;
    .img-container{
        height:9.4rem;
        width: 100%;
        img{
            width:100%;
            height:100%;
            display: block;
            border-radius: 0.5rem;
        }
    }
    .content-container{
        font-size: 0.6rem;
        color: #00448a;
        line-height: 1.1rem;
        margin-top:0.6rem;
        margin-bottom: 1rem;
    }
    .content{
        color:#00448a;
        margin-bottom: 1rem;
        font-size: 0.6rem;
        line-height: 1rem;
    }
    .buy-container{
        position: fixed;
        z-index:9999999;
        left:50%;
        transform: translateX(-50%);
        bottom:0.5rem;
        width: 4.7rem;
        height: 1.6rem;
        background: #219cdc;
        border-radius: 0.2rem;
        padding-left:0.55rem;
        padding-right:0.55rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        img{
            height:0.8rem;
        }
        .goumai{
            color: #ffffff;
            line-height: 0.65rem;
        }
    }
}
</style>